require ('select2')

$(".role-select").select2({
    tags: true,
    tokenSeparators: [',', ' ']
})
